


import {
    Form,
    Button,
    Empty,
    Icon,
    Input,
    Modal,
    Popconfirm,
    Table,
    Upload,
    Avatar,
    Row,
    Col,
    Tooltip,
    InputNumber
} from 'antd';
import React, { useState } from 'react'
import {
    contractSource,
    mapRentContractApprovalType,
    mapRentContractApprovalStatus,
    dicRentContractFirstLastRentType
} from '../../../../axios/dictionaries';
import { CustomCol, CustomRow } from '../../../../components/Custom';
import DetailTitle from '../../../../components/DetailTitle';
import ModalScrollContainer from '../../../../components/ModalScrollContainer';
import FileView from "../../../../components/FileView";
import { fetchRentContractApplyGet } from "../../../../services/rentContractApply";
import {findDict, formatTime, moneyAddComma} from '../../../../utils';
import moment from "moment";
import TextArea from "antd/lib/input/TextArea";
const RentContractReviewDetail = (props) => {
    const [visible, setVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    const [detailData, setDetailData] = useState({});
    const open = (id) => {
        setVisible(true)
        postDetail(id)
    }
    const close = () => {
        setVisible(false)
    }

    const postDetail = (id) => {
        setLoading(true)
        fetchRentContractApplyGet({id}).then(res => {
            setDetailData(res)
        }).finally(() => {
            setLoading(false)
        })
    }
    props.getRef && props.getRef({ open });


    const furnitureColumns = [
        { title: '物品名称', dataIndex: 'name', },
        { title: '物品数量', dataIndex: 'amount', },
        { title: '物品总价', dataIndex: 'totalPrice', },
        { title: '物品单价', dataIndex: 'unitPrice', },

    ]



    const approvalRecordColumns = [
        { title: '审核人', dataIndex: 'approvalUserName', },
        { title: '审核类型', dataIndex: 'approvalType', render: (text) => {
            return findDict(mapRentContractApprovalType, text).title
        }},
        { title: '审批状态', dataIndex: 'approvalStatus', render: (text) => {
            return findDict(mapRentContractApprovalStatus, text).title
        }},
        { title: '审核备注信息', dataIndex: 'approvalRemark', },
        { title: '审核时间', dataIndex: 'approvalTime', render: formatTime},
       
    ]

    // let {
    //     contractUrl
    // } = this.state;

    let contractSources = detailData instanceof Object ? contractSource.find(item => detailData.contractSource === item.value) : null

    return (
        <Modal 
            title="合同申请记录详情"
            width={1290}
            visible={visible} 
            onCancel={close} 
            footer={<Button onClick={close}>关闭</Button>}
        >
             <ModalScrollContainer style={{ paddingTop: 0 }} loading={loading}>
                 <div className="custom" style={{ paddingBottom: "20px" }}>
                     {
                         detailData.customerType === 2 ?
                             <div className="sign_input_box">
                                 <Row>
                                     <Col>
                                         <DetailTitle title="租客信息" />
                                         <CustomRow divider>
                                             <CustomCol label="姓名" required={false} required={false}>
                                                 <Input
                                                     disabled={true}
                                                     value={detailData.customerName}
                                                 />
                                             </CustomCol>
                                             <CustomCol label="手机号码"  required={false}>
                                                 <Input
                                                     disabled={true}
                                                     value={detailData.customerPhone}
                                                 />
                                             </CustomCol>
                                         </CustomRow>
                                     </Col>
                                 </Row>
                                 <Row>
                                     <Col>
                                         <CustomRow divider>
                                             <CustomCol required={false} label="联系人" required={false}>
                                                 <Input
                                                     disabled={true}
                                                     value={detailData.linkmanName}
                                                 />
                                             </CustomCol>
                                             <CustomCol required={false} label="手机号码" required={false}>
                                                 <Input
                                                     disabled={true}
                                                     value={detailData.linkmanPhone}
                                                 />
                                             </CustomCol>
                                         </CustomRow>
                                     </Col>
                                 </Row>
                             </div>
                             :
                             <div className="sign_input_box">
                                 <Row>
                                     <Col>
                                         <DetailTitle title="租客信息" />
                                         <CustomRow divider>
                                             <CustomCol label="企业名称" required={false}>
                                                 <Input
                                                     disabled={true}
                                                     value={detailData.customerName}
                                                 />
                                             </CustomCol>
                                         </CustomRow>
                                     </Col>
                                 </Row>
                                 <Row>
                                     <Col>
                                         <CustomRow divider>
                                             <CustomCol label="联系人" required={false}>
                                                 <Input
                                                     disabled={true}
                                                     value={detailData.linkmanName}
                                                 />
                                             </CustomCol>
                                             <CustomCol label="手机号码" required={false}>
                                                 <Input
                                                     disabled={true}
                                                     value={detailData.linkmanPhone}
                                                 />
                                             </CustomCol>
                                         </CustomRow>
                                     </Col>
                                 </Row>
                             </div>
                     }
                     <DetailTitle title="房源" />
                     <CustomRow divider>
                         <CustomCol label="楼栋/楼盘" required={false} >
                             <Input
                                 disabled={true}
                                 value={detailData.buildingName}
                             />
                         </CustomCol>
                         <CustomCol label="房间号" required={false} >
                             <Input
                                 disabled={true}
                                 value={detailData.roomNo}
                             />
                         </CustomCol>
                     </CustomRow>
                     <DetailTitle title="合同" />
                     <CustomRow divider>
                         <CustomCol label="签约类型" required={false} >
                             <Input
                                 disabled={true}
                                 value={contractSources ? contractSources.title : null}
                             />
                         </CustomCol>
                         {
                             // 如果为补录 , 则显示账单生成日和是否创建电子合同
                             contractSources && contractSources.value === 4 &&
                             <React.Fragment>
                                 <CustomCol label="账单生成日" required={false} >
                                     <Input
                                         disabled={ true }
                                         value={ detailData.billBeginDate ? moment(detailData.billBeginDate).format('YYYY-MM-DD') : "" }
                                     />
                                 </CustomCol>
                                 <CustomCol label="创建电子合同" required={false} >
                                     <Input
                                         disabled={ true }
                                         value={ detailData.createElectronicContract ? "是" : "否" }
                                     />
                                 </CustomCol>
                             </React.Fragment>
                         }
                     </CustomRow>
                     <CustomRow divider>
                         <CustomCol label="起租日" required={false} >
                             <Input
                                 disabled={true}
                                 value={detailData.beginDate ? moment(detailData.beginDate).format('YYYY-MM-DD') : ""}
                             />
                         </CustomCol>
                         <CustomCol label="到期日" required={false} >
                             <Input
                                 disabled={true}
                                 value={detailData.endDate ? moment(detailData.endDate).format('YYYY-MM-DD') : ""}
                             />
                         </CustomCol>
                     </CustomRow>
                     <CustomRow divider >
                         <CustomCol label="常规押金" required={false} subfix={<div style={{ background: "#f5f5f5" }}>元</div>}>
                             <Input
                                 disabled={true}
                                 value={moneyAddComma(detailData.normalDeposit)}
                             />
                         </CustomCol>
                         <CustomCol label="门卡押金" required={false} subfix={<div style={{ background: "#f5f5f5" }}>元</div>}>
                             <Input
                                 disabled={true}
                                 value={moneyAddComma(detailData.doorCardDeposit)}
                             />
                         </CustomCol>
                     </CustomRow>
                     <CustomRow divider>
                         <CustomCol label="租金" required={false} subfix={<div style={{ background: "#f5f5f5" }}>元</div>}>
                             <Input
                                 disabled={true}
                                 value={moneyAddComma(detailData.monthlyFee)}
                             />
                         </CustomCol>
                         <CustomCol label="宽带费" required={false} subfix={<div style={{ background: "#f5f5f5" }}>元</div>}>
                             <Input
                                 disabled={true}
                                 value={moneyAddComma(detailData.networkFee)}
                             />
                         </CustomCol>
                         <CustomCol label="物业费" required={false} subfix={<div style={{ background: "#f5f5f5" }}>元</div>}>
                             <Input
                                 disabled={true}
                                 value={moneyAddComma(detailData.propertyFee)}
                             />
                         </CustomCol>
                         <CustomCol label="零散租期" required={false}>
                             <Input
                                 disabled={true}
                                 value={
                                     detailData.firstLastRentType
                                         ? dicRentContractFirstLastRentType.filter(item => {
                                             return detailData.firstLastRentType === item.value
                                         })[0].title
                                         : ""
                                 }
                             />
                         </CustomCol>

                     </CustomRow>
                     {
                         detailData.firstLastRentType == 2
                             ? <React.Fragment>
                                 <CustomRow divider >
                                     <CustomCol label="首期" required={false}>
                                         <div className="datePickerNopadding" style={{ display: 'flex' }}>
                                             <Input
                                                 disabled={true}
                                                 value={detailData.firstRentStartDate ? moment(detailData.firstRentStartDate).format('YYYY-MM-DD') : ""}
                                             />
                                             <span style={{ padding: '0 5px', height: '100%', lineHeight: '34px', background: '#f5f5f5' }}>至</span>
                                             <Input
                                                 disabled={true}
                                                 value={detailData.firstRentEndDate ? moment(detailData.firstRentEndDate).format('YYYY-MM-DD') : ""}
                                             />
                                         </div>
                                     </CustomCol>
                                     <CustomCol label="租金" required={false} subfix={<div style={{ background: "#f5f5f5" }}>元</div>}>
                                         <Input
                                             disabled={true}
                                             value={moneyAddComma(detailData.firstRentFee)}
                                         />
                                     </CustomCol>
                                     <CustomCol label="宽带费" required={false} subfix={<div style={{ background: "#f5f5f5" }}>元</div>}>
                                         <Input
                                             disabled={true}
                                             value={moneyAddComma(detailData.firstRentNetworkFee)}
                                         />
                                     </CustomCol>
                                     <CustomCol label="物业费" required={false} subfix={<div style={{ background: "#f5f5f5" }}>元</div>}>
                                         <Input
                                             disabled={true}
                                             value={moneyAddComma(detailData.firstRentPropertyFee)}
                                         />
                                     </CustomCol>
                                 </CustomRow>
                                 <CustomRow divider >
                                     <CustomCol label="末期" required={false}>
                                         <div className="datePickerNopadding" style={{ display: 'flex' }}>
                                             <Input
                                                 disabled={true}
                                                 value={detailData.lastRentStartDate ? moment(detailData.lastRentStartDate).format('YYYY-MM-DD') : ""}
                                             />
                                             <span style={{ padding: '0 5px', height: '100%', lineHeight: '34px', background: '#f5f5f5' }}>至</span>
                                             <Input
                                                 disabled={true}
                                                 value={detailData.lastRentEndDate ? moment(detailData.lastRentEndDate).format('YYYY-MM-DD') : ""}
                                             />
                                         </div>
                                     </CustomCol>
                                     <CustomCol label="租金" required={false} subfix={<div style={{ background: "#f5f5f5" }}>元</div>}>
                                         <Input
                                             disabled={true}
                                             value={moneyAddComma(detailData.lastRentFee)}
                                         />
                                     </CustomCol>
                                     <CustomCol label="宽带费" required={false} subfix={<div style={{ background: "#f5f5f5" }}>元</div>}>
                                         <Input
                                             disabled={true}
                                             value={moneyAddComma(detailData.lastRentNetworkFee)}
                                         />
                                     </CustomCol>
                                     <CustomCol label="物业费" required={false} subfix={<div style={{ background: "#f5f5f5" }}>元</div>}>
                                         <Input
                                             disabled={true}
                                             value={moneyAddComma(detailData.lastRentPropertyFee)}
                                         />
                                     </CustomCol>
                                 </CustomRow>
                             </React.Fragment>
                             : null
                     }
                     <CustomRow divider >
                         <CustomCol label="付款日" required={false}>
                             <Input
                                 disabled={true}
                                 value={`每月${detailData.payDay}日`}
                             />
                         </CustomCol>
                     </CustomRow>
                     <CustomRow divider >
                         <CustomCol label="合同补充条款" labelStyle={{ height: '100px' }} colStyle={{ width: "500px" }} height="100px" required={false}>
                             <TextArea
                                 disabled={true}
                                 style={{ height: '100px' }}
                                 value={detailData.contractRemark}
                             />
                         </CustomCol>
                     </CustomRow>
                     {
                         detailData.contractType === 1 ?
                             <CustomRow divider>
                                 <CustomCol label="签约类型" required={false}>
                                     <Input
                                         disabled={true}
                                         value={detailData.contractType ? detailData.contractType === 1 ? "电子" : "纸质" : ""}
                                     />
                                 </CustomCol>
                                 <CustomCol label="合同编号" required={false}>
                                     <Input
                                         disabled={true}
                                         value={detailData.contractNo}
                                     />
                                 </CustomCol>
                                 <CustomCol label="电子合同" required={false}>
                                     <Input
                                         disabled={true}
                                         value={detailData.contractTemplateName}
                                     />
                                 </CustomCol>
                                 <div className="flex-static" style={{ marginLeft: "10px" }}>
                                     {
                                         detailData.contractSource === 4 && !detailData.createElectronicContract ?
                                                 null :
                                                 <span className="showClickDetail" onClick={this.handleGetPreviewUrl}>预览合同</span>
                                     }
                                 </div>
                             </CustomRow>
                             :
                             detailData.contractType === 2 ?
                                 <CustomRow divider >
                                     <CustomCol label="合同类型" required={false}>
                                         <Input
                                             disabled={true}
                                             value={detailData.contractType ? detailData.contractType === 1 ? "电子" : "纸质" : ""}
                                         />
                                     </CustomCol>
                                     <CustomCol label="合同编号" required={false}>
                                         <Input
                                             disabled={true}
                                             value={detailData.contractNo}
                                         />
                                     </CustomCol>
                                     <CustomCol label="纸质合同" required={false} >
                                    <span
                                        style={{
                                            display: 'block',
                                            padding: '0 11px',
                                            height: '100%',
                                            color: detailData.paperAttachList instanceof Array && detailData.paperAttachList.length ? 'rgba(0, 0, 0, 0.65)' : 'rgb(192, 191, 191)',
                                            whiteSpace: 'nowrap',
                                            overflowX: 'auto',
                                            overflowY: 'hidden',
                                        }}
                                    >
                                        {
                                            detailData.paperAttachList instanceof Array && detailData.paperAttachList.length
                                                ? detailData.paperAttachList.map((item, index) => {
                                                    if (item.attachType == 5) {
                                                        return <span key={index}>
                                                            <a
                                                                href={item.fileUrl}
                                                                download
                                                                className="showClickDetail"
                                                                style={{ color: 'inherit' }}
                                                                target="_blank"
                                                            >{item.fileName}；</a>
                                                        </span>
                                                    }

                                                })
                                                : "未上传"
                                        }
                                    </span>
                                     </CustomCol>
                                     <div className="center" style={{ marginLeft: '10px' }} onClick={() => { this.setState({ isAttachType: 5 }) }}>
                                     </div>
                                 </CustomRow>
                                 : ""
                     }
                     <CustomRow divider >
                         <CustomCol label="附件" required={false} colStyle={{ width: '500px' }}>
                        <span
                            style={{
                                display: 'block',
                                padding: '0 11px',
                                height: '100%',
                                color: detailData.attachList instanceof Array && detailData.attachList.length ? 'rgba(0, 0, 0, 0.65)' : 'rgb(192, 191, 191)',
                                whiteSpace: 'nowrap',
                                overflowX: 'auto',
                                overflowY: 'hidden',
                            }}
                        >
                            {
                                detailData.attachList instanceof Array && detailData.attachList.length
                                    ? detailData.attachList.map((item, index) => {
                                        if (item.attachType == 1) {
                                            return <span key={index}>
                                                <a
                                                    href={item.fileUrl}
                                                    download
                                                    className="showClickDetail"
                                                    style={{ color: 'inherit' }}
                                                    target="_blank"
                                                >{item.fileName}；</a>
                                            </span>
                                        }

                                    })
                                    : "未上传"
                            }
                        </span>
                         </CustomCol>
                     </CustomRow>
                     <CustomRow divider >
                         <CustomCol label="办理部门" required={false}>
                             <Input
                                 disabled={true}
                                 value={detailData.merchantDepartmentName}
                             />
                         </CustomCol>
                         <CustomCol label="办理人" required={false}>
                             <Input
                                 disabled={true}
                                 value={detailData.merchantUserName}
                             />
                         </CustomCol>
                         <CustomCol label="办理日期" required={false}>
                             <Input
                                 disabled={true}
                                 value={detailData.signDate ? moment(detailData.signDate).format('YYYY-MM-DD') : ""}
                             />
                         </CustomCol>
                     </CustomRow>
                     <CustomRow divider >
                         <CustomCol label="办理备注" required={false} colStyle={{ width: '500px' }}>
                             <Input
                                 disabled={true}
                                 value={detailData.remark}
                             />
                         </CustomCol>
                     </CustomRow>
                     <DetailTitle title="审批信息" />
                     <CustomRow divider >
                         <CustomCol label="审核人" required={false} >
                             <Input
                                 disabled={true}
                                 value={detailData.approvalUserName}
                             />
                         </CustomCol>
                         <CustomCol label="审核时间" required={false} >
                             <Input
                                 disabled={true}
                                 value={formatTime(detailData.approvalTime)}
                             />
                         </CustomCol>
                         <CustomCol label="审核类型" required={false} >
                             <Input
                                 disabled={true}
                                 value={findDict(mapRentContractApprovalType,detailData.approvalType).title}
                             />
                         </CustomCol>
                     </CustomRow>
                     <CustomRow divider>
                         <CustomCol label="审核状态" required={false} >
                             <Input
                                 disabled={true}
                                 value={findDict(mapRentContractApprovalStatus, detailData.applyStatus).title}
                             />
                         </CustomCol>
                         <CustomCol label="审核备注信息" required={false} colStyle={{ width: '500px' }}>
                             <Input
                                 disabled={true}
                                 value={detailData.approvalRemark}
                             />
                         </CustomCol>
                     </CustomRow>
                     <DetailTitle title="房间物品" />
                     <Table columns={furnitureColumns} dataSource={detailData.furnitureList} />
                     <DetailTitle title="流程记录" />
                     <Table columns={approvalRecordColumns} dataSource={detailData.approvalRecordList} />
                </div>
            </ModalScrollContainer>
        </Modal>
    )
}

export default RentContractReviewDetail



// WEBPACK FOOTER //
// ./src/page/RentContract/components/ContractReviewDetail/index.jsx